<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="siteTreatmentForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                siteTreatmentForm: () => import('../forms/SiteTreatmentForm'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Site', value: 'siteId', table: 'sites', form: () => import('../forms/SiteForm') },
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Chemical Purchase', value: 'chemicalPurchaseId', table: 'chemicalPurchases', form: () => import('../forms/ChemicalPurchaseForm') },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    chemicalPurchases: [],
                    inspections: [],
                    sites: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "siteId", direction: "ascending" },
                    { column: "inspectionId", direction: "ascending" },
                    { column: "chemicalPurchaseId", direction: "ascending" },
                ],
                itemsField: 'siteTreatments',
                editPageName: 'siteTreatment',
                apiMethod: 'SiteTreatments',
                claimName: 'SiteTreatments',
                formTitle: 'Site Treatment',
                excelTitle: 'Site Treatments',
                hasEditPage: false,
            }
        },
    };
</script>
